/**
 * Color tokens
 *
 * @module @smoothie-framework/ui-core/tokens
 */
/**
 * Map a token path to its canonical primitive path.
 *
 * Alias remapping is not applied, so the input path is returned as-is.
 */
export function mapColorTokenPath(path) {
    return path;
}
export const colors = {
    neutral: {
        50: '#f6f7f8', 100: '#f1f1f4', 200: '#e3e3e8', 300: '#d4d5dd', 400: '#b8b9c7',
        500: '#7e829a', 600: '#4f5164', 700: '#383a47', 800: '#22232b', 900: '#16171d',
    },
    green: {
        50: '#f1fdf4', 100: '#dcfce8', 200: '#bcf8d0', 300: '#86f0ad', 400: '#4bde80',
        500: '#22c55f', 600: '#17a34a', 700: '#106a32', 800: '#032713', 900: '#03180c',
    },
    yellow: {
        50: '#fefce8', 100: '#fef9c3', 200: '#fef18b', 300: '#fde047', 400: '#facc14',
        500: '#ebb30b', 600: '#ca8a03', 700: '#845208', 800: '#432005', 900: '#281304',
    },
    red: {
        50: '#fef3f2', 100: '#ffe2e3', 200: '#fecaca', 300: '#fda5a5', 400: '#f97171',
        500: '#ef4444', 600: '#dc2627', 700: '#9a1919', 800: '#300c0c', 900: '#1f0808',
    },
    blue: {
        50: '#f0f6ff', 100: '#dbeafe', 200: '#c0dbfe', 300: '#a3cfff', 400: '#61a6fb',
        500: '#3b83f6', 600: '#2663eb', 700: '#173da6', 800: '#13204a', 900: '#0b142e',
    },
};
//# sourceMappingURL=colors.js.map